import { useState, useMemo } from 'preact/hooks';
export function useTouchPointGroups({ touchPoints, groupBy }) {
    const [expandedGroups, setExpandedGroups] = useState({});
    // Group touchpoints using the provided groupBy function
    const groupedTouchPoints = useMemo(() => {
        return touchPoints.reduce((acc, tp) => {
            const groupKey = groupBy(tp);
            if (!acc[groupKey]) {
                acc[groupKey] = [];
            }
            acc[groupKey].push(tp);
            return acc;
        }, {});
    }, [touchPoints, groupBy]);
    // Toggle group expansion
    const toggleGroup = (groupKey) => {
        setExpandedGroups(prev => ({ ...prev, [groupKey]: !prev[groupKey] }));
    };
    // Check if a group is expanded (default to false for collapsed)
    const isGroupExpanded = (groupKey) => {
        return expandedGroups[groupKey] ?? false;
    };
    return {
        groupedTouchPoints,
        expandedGroups,
        toggleGroup,
        isGroupExpanded,
    };
}
